import { render, staticRenderFns } from "./MainNav.vue?vue&type=template&id=366b0f44&"
import script from "./MainNav.vue?vue&type=script&lang=ts&"
export * from "./MainNav.vue?vue&type=script&lang=ts&"
import style0 from "./MainNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports